import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Users } from 'lucide-react';
import { categorie } from '../data/mock';

const colors = [
  { from: 'from-[#36a9e1]', to: 'to-[#1e7ba8]', img: 'https://images.unsplash.com/photo-1574629810360-7efbbe195018?w=800' },
  { from: 'from-[#0891b2]', to: 'to-[#0369a1]', img: 'https://images.unsplash.com/photo-1526232761682-d26e03ac148e?w=800' },
  { from: 'from-[#16a34a]', to: 'to-[#065f46]', img: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=800' },
];

export default function CategoriesSection() {
  return (
    <section className="py-20 bg-navy-dark">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="section-title centered text-4xl md:text-5xl">Categorie in Campo</h2>
          <p className="text-white/70 mt-6 max-w-2xl mx-auto">
            24 squadre in 3 categorie si contenderanno il XIV Memorial Eugenio Abbro
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {categorie.map((c, i) => {
            const style = colors[i % colors.length];
            return (
              <Link
                key={c.key}
                to={`/squadre?cat=${c.key}`}
                className="group relative overflow-hidden rounded-2xl h-72 block"
              >
                <img
                  src={style.img}
                  alt={c.label}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${style.from} ${style.to} opacity-75 group-hover:opacity-85 transition-opacity`}></div>
                <div className="absolute inset-0 bg-gradient-to-t from-navy-dark via-transparent to-transparent"></div>
                <div className="relative h-full p-7 flex flex-col justify-between">
                  <div className="flex items-center gap-2 bg-white/20 backdrop-blur border border-white/30 rounded-full px-3 py-1.5 self-start">
                    <Users size={14} className="text-white" />
                    <span className="text-white text-xs font-bold">{c.squadre.length} squadre</span>
                  </div>
                  <div>
                    <div className="text-white/80 text-xs font-semibold uppercase tracking-widest">
                      Categoria
                    </div>
                    <h3 className="font-display text-3xl md:text-4xl font-bold text-white uppercase mt-1">
                      {c.label}
                    </h3>
                    <div className="mt-4 inline-flex items-center gap-2 text-white font-bold text-sm group-hover:gap-4 transition-all">
                      Scopri le squadre <ArrowRight size={16} />
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
